import { __decorate } from "tslib";
import __NG_CLI_RESOURCE__0 from "./view-application-add-note.component.html?ngResource";
import __NG_CLI_RESOURCE__1 from "./view-application-add-note.component.scss?ngResource";
import { ChangeDetectionStrategy, ChangeDetectorRef, Component } from "@angular/core";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { ViewApplicationAddNoteConstants } from "./view-application-add-note.constants";
import { SharedConstants } from "../../../shared/constants/shared.constants";
import { AlertType } from "../../../shared/models/alert";
import { ApplicationBaseComponent } from "../../../shared/components/application-base/application-base.component";
import { ActivatedRoute } from "@angular/router";
import { RouterParamsService } from "../../../shared/services/route-params.service";
import { AppControllerService } from "../../../app-controller.service";
import { CRUDOperation } from "../../../shared/models/crud-operation-enum.model";
import { ViewApplicationService } from "../view-application.service";
import { AflaModuleStrategyService } from "../../../shared/services/afla-module-strategy/afla-module-strategy.service";
import { aflaModuleServiceProvider } from "../../../shared/services/afla-module-strategy/afla-module-strategy.service.provider";
import { ServerNotificationService } from "../../../shared/services/server-notification/server-notification.service";
import { CurrentStepService } from "src/app/shared/services/current-step/current-step.service";
let ViewApplicationAddNoteComponent = class ViewApplicationAddNoteComponent extends ApplicationBaseComponent {
    appController;
    viewApplicationService;
    currentStepService;
    route;
    notification;
    aflaModuleStrategyService;
    routerParamsService;
    changeDetectorRef;
    noteForm;
    validationMessage = ViewApplicationAddNoteConstants.VALIDATION_MESSAGE;
    addNotePlaceHolderText = SharedConstants.ADD_NOTE_PLACEHOLDER;
    noteCharacterLimit = SharedConstants.NOTE_CHARACTER_LIMIT;
    saveNoteText = ViewApplicationAddNoteConstants.SAVE_NOTE_TEXT;
    noteFormControlName = ViewApplicationAddNoteConstants.NOTE_FORM_CONTROL_NAME;
    linkNoteToStepFormControlName = ViewApplicationAddNoteConstants.LINK_NOTE_TO_STEP_FORM_CONTROL_NAME;
    linkNoteToStepLabel = ViewApplicationAddNoteConstants.LINK_NOTE_TO_STEP_LABEL;
    showIfCurrentStepSelected = false;
    isLinkedToStep = false;
    currentStepId = null;
    getNotesPostObservableSubscription;
    currentEventSubscription;
    paramsSubscription;
    constructor(appController, viewApplicationService, currentStepService, route, notification, aflaModuleStrategyService, routerParamsService, changeDetectorRef) {
        super(route, routerParamsService, aflaModuleStrategyService);
        this.appController = appController;
        this.viewApplicationService = viewApplicationService;
        this.currentStepService = currentStepService;
        this.route = route;
        this.notification = notification;
        this.aflaModuleStrategyService = aflaModuleStrategyService;
        this.routerParamsService = routerParamsService;
        this.changeDetectorRef = changeDetectorRef;
    }
    ngOnInit() {
        this.listenForCurrentSteps();
        this.listenForRouteParamChange();
        this.initialiseForm();
    }
    ngOnDestroy() {
        this._destroy$.next();
        this._destroy$.complete();
    }
    handleRouteChange() {
        // no need to do anything. Extending the base class to get the job id when submitting the note
    }
    listenForCurrentSteps() {
        this.paramsSubscription = this.routerParamsService.params.subscribe(params => {
            if (params.stepID !== null && params.stepID !== undefined) {
                this.showIfCurrentStepSelected = true;
                this.currentEventSubscription = this.currentStepService.getCurrentStepEvent.subscribe(data => {
                    this.currentStepId = data.id;
                });
            }
            else {
                this.showIfCurrentStepSelected = false;
            }
            this.changeDetectorRef.markForCheck();
        });
    }
    onLinkNoteToStepChecked($event) {
        const input = $event.target.checked;
        this.isLinkedToStep = input;
        if (this.isLinkedToStep) {
            this.currentEventSubscription = this.currentStepService.getCurrentStepEvent.subscribe(data => {
                this.currentStepId = data.id;
            });
        }
        else {
            this.currentStepId = null;
        }
    }
    initialiseForm() {
        this.noteForm = new FormGroup({
            note: new FormControl(null, [Validators.required]),
            linkNoteToStep: new FormControl(this.showIfCurrentStepSelected)
        });
    }
    addNote($event) {
        const noteControl = this.noteForm.get(this.noteFormControlName);
        noteControl.updateValueAndValidity();
        this.noteForm.updateValueAndValidity();
        if (!this.noteForm.valid) {
            this.appController.showMessage(SharedConstants.FORM_NOT_VALID, AlertType.Warning);
            return;
        }
        const note = {
            date: new Date(),
            deleted: false,
            jobId: this.jobID,
            workflowStepId: this.currentStepId,
            id: 0,
            note: noteControl.value,
            user: null,
            userId: 0,
            userName: "",
        };
        this.getNotesPostObservableSubscription = this.viewApplicationService.getNotesPostObservable(note)
            .subscribe({
            next: result => {
                this.currentStepService.addSessionNoteId(result.id);
                this.appController.showMessage(SharedConstants.ADD_SUCCESS, AlertType.Success);
                this.currentStepService.getCurrentNotes(this.jobID).subscribe({
                    next: data => {
                        this.noteForm.reset();
                        this.isLinkedToStep = false;
                        this.currentStepId = null;
                    }, error: error => {
                        this.appController.handleServerErrorMessage(ViewApplicationAddNoteConstants.COMPONENT_NAME, error, CRUDOperation.Add);
                    }
                });
            }, error: error => {
                this.appController.handleServerErrorMessage(ViewApplicationAddNoteConstants.COMPONENT_NAME, error, CRUDOperation.Add);
            }
        });
    }
    static ctorParameters = () => [
        { type: AppControllerService },
        { type: ViewApplicationService },
        { type: CurrentStepService },
        { type: ActivatedRoute },
        { type: ServerNotificationService },
        { type: AflaModuleStrategyService },
        { type: RouterParamsService },
        { type: ChangeDetectorRef }
    ];
};
ViewApplicationAddNoteComponent = __decorate([
    Component({
        selector: "app-view-application-add-note",
        providers: [aflaModuleServiceProvider],
        template: __NG_CLI_RESOURCE__0,
        changeDetection: ChangeDetectionStrategy.OnPush,
        styles: [__NG_CLI_RESOURCE__1]
    })
], ViewApplicationAddNoteComponent);
export { ViewApplicationAddNoteComponent };
